import moment from 'moment';

export const formatLastLogin = (lastLogin) => {
  if (lastLogin && moment(lastLogin).isValid()) {
    return moment(lastLogin).utc().format("DD MMM YYYY [at] HH:mm");
  }
}